var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 200,
    viewBox: "0 0 732 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.973 144.808L327.932 49.9662H257.92V31.3662H354.422V48.1052L283.463 142.952H355.369V161.547H256.973V144.808Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.827 31.3662H385.642V50.8919H364.827V31.3662ZM365.774 68.5614H384.695V161.547H365.774V68.5614Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.052 68.5645H412.137L414.031 76.934H414.977C418.195 73.4001 421.222 68.5645 432.956 68.5645H449.988V85.3035H434.85C421.605 85.3035 414.982 91.812 414.982 104.646V161.555H396.062V68.5693L396.052 68.5645Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M539.856 128.998C536.83 142.946 524.718 163.402 496.334 163.402C467.951 163.402 449.03 143.876 449.03 115.05C449.03 86.2249 468.897 66.6992 496.334 66.6992C523.771 66.6992 536.83 87.3434 539.856 100.172H520.936C517.909 91.8029 510.717 83.4334 496.339 83.4334C480.254 83.4334 467.956 95.708 467.956 115.046C467.956 134.383 480.254 146.663 496.339 146.663C511.478 146.663 518.856 136.432 520.936 128.998H539.856Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.316 68.5645H568.236V124.355C568.236 136.441 577.886 146.672 590.944 146.672C605.136 146.672 615.546 136.441 615.546 124.355V68.5645H634.466V161.55H617.434L615.541 152.25H614.594C612.514 154.294 610.243 156.155 607.594 157.828C603.051 160.619 596.051 163.406 587.157 163.406C564.449 163.406 549.311 148.716 549.311 124.355V68.5645H549.316Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M646.76 31.3662H667.574V50.8919H646.76V31.3662ZM647.707 68.5614H666.628V161.547H647.707V68.5614Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M691.229 86.2301H676.09V68.5654H691.229V42.5312H710.149V68.5654H731.91V86.2301H710.149V139.229C710.149 142.946 712.043 144.807 715.825 144.807H731.91V161.546H712.043C698.607 161.546 691.229 154.107 691.229 142.02V86.2301Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 100.004C0 44.7722 44.6407 0 99.7008 0C154.771 0 199.411 44.7722 199.407 99.9995C199.407 119.562 193.804 137.81 184.126 153.219C181.457 157.465 178.484 161.495 175.227 165.283L99.8333 89.6674L35.0012 154.686L24.2973 165.421C21.0302 161.642 18.0476 157.618 15.379 153.377C5.6365 137.938 0 119.63 0 100.004ZM172.696 138.971L173.608 137.141L173.613 137.146C179.333 125.702 182.355 112.856 182.355 100.004C182.355 54.2974 145.278 17.1118 99.7057 17.1118C54.133 17.1118 17.0616 54.2974 17.0616 100.004C17.0616 112.924 20.1128 125.825 25.8867 137.313L26.804 139.133L99.8333 65.889L172.696 138.971ZM99.7048 200C124.527 200 147.235 190.903 164.689 175.848V175.843L99.8372 110.8L34.8629 175.961C52.2924 190.953 74.8826 200 99.7048 200Z",
    fill: "url(#paint0_linear_6469_19411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6469_19411",
    x1: 99.7033,
    y1: -1.26496e-8,
    x2: 99.9993,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00C537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1C9"
  })))));
};
export default SvgLogo;